import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkLogin(state.url);
  }

  checkLogin(url: string): boolean {
    if (this.checkToken()) {
      return true;
    }

    // Navigate to the login page with extras
    this.router.navigate(['/login'],
      { queryParams: { returnUrl: url } }
    );
    return false;
  }

  checkToken() {
    return sessionStorage.getItem('access_token');
  }

}




